import * as firebaseAnalytics from "firebase/analytics";

import { analytics } from "configs";

enum LogEvents {
  "submit_email" = "submit_email",
  "unlock_all_features" = "unlock_all_features",
  "generate_route" = "generate_route",
  "navigate" = "navigate",
  "navigate_from_routes_list" = "navigate_from_routes_list",
  "share_route" = "share_route",
  "share_route_from_routes_list" = "share_route_from_routes_list",
  "view_place_in_google_maps" = "view_place_in_google_maps",
  "reset_preferences_and_start_over" = "reset_preferences_and_start_over",
  "support_us" = "support_us",
  "search_hotels_and_campings" = "search_hotels_and_campings",
}

export const setUserID = (id: string) => {
  if (process.env.NODE_ENV === "production" && analytics) {
    firebaseAnalytics.setUserId(analytics, id, { global: true });
    firebaseAnalytics.logEvent(analytics, LogEvents.submit_email);
  }
};

export const logEvent = (event: keyof typeof LogEvents, params: Object) => {
  if (process.env.NODE_ENV === "production" && analytics) {
    firebaseAnalytics.logEvent(analytics, event, params);
  }
};
